import { ReactNode } from 'react';

import FilterContainer from 'components/filters/FilterContainer';
import useFilterIcon from 'hooks/useFilterIcon';

interface CommonFiltersContainerProps {
  children: ReactNode;
  searchField?: ReactNode;
  stateStorageKey: string;
}

const CommonFiltersContainer = ({
  children,
  searchField,
  stateStorageKey,
}: CommonFiltersContainerProps) => {
  const { isFilterOpen, filterIconWithCounterFromForm: FilterIconRenderer } =
    useFilterIcon({
      stateStorageKey,
    });

  return (
    <>
      <div className="actions-container">
        {searchField}
        <FilterIconRenderer />
      </div>
      {isFilterOpen && <div className="divider" />}
      <FilterContainer isCollapsed={!isFilterOpen}>{children}</FilterContainer>
    </>
  );
};

export default CommonFiltersContainer;
